import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IBiEngagementState } from './types';

const initialState: IBiEngagementState = {
  mouseClick: false,
  mouseMove: false,
  scroll: false,
  scrollToBottom: false,
  scrollAddedContent: false,
  maxScrollAtFirstPosition: false,
  scrollPercentage: 0,
};

export const biEngagementSlice = createSlice({
  name: 'biEngagement',
  initialState,
  reducers: {
    setMouseClick: (state, action: PayloadAction<boolean>) => {
      state.mouseClick = action.payload;
    },
    setMouseMove: (state, action: PayloadAction<boolean>) => {
      state.mouseMove = action.payload;
    },
    setScroll: (state, action: PayloadAction<boolean>) => {
      state.scroll = action.payload;
    },
    setScrollToBottom: (state, action: PayloadAction<boolean>) => {
      state.scrollToBottom = action.payload;
    },
    setScrollAddedContent: (state, action: PayloadAction<boolean>) => {
      state.scrollAddedContent = action.payload;
    },
    setMaxScrollAtFirstPosition: (state, action: PayloadAction<boolean>) => {
      state.maxScrollAtFirstPosition = action.payload;
    },
    setScrollPercentage: (state, action: PayloadAction<number>) => {
      state.scrollPercentage = action.payload;
    },
    reset: () => initialState,
  },
});
